module.exports = __webpack_public_path__ + "img/pay-sdk-transaction-error.622b7cf2.png";